import { object, string } from 'yup';
import { MAX_SHORT_TEXT_LENGTH } from '../../constants';
import { VendorRebateCategoryProgramChangeReasonEntity } from '../../models';
import { ApiErrorCodes, EntityFormSchema } from '../../types';

const _reason_En = string().max(MAX_SHORT_TEXT_LENGTH);

export const VendorRebateCategoryProgramChangeReasonSchema = (
  changeReasonRequired = false,
): EntityFormSchema<VendorRebateCategoryProgramChangeReasonEntity> => ({
  schema: object().shape({
    reason_En: changeReasonRequired ? _reason_En.required() : _reason_En,
    reason_Fr: string().nullable().notRequired().max(MAX_SHORT_TEXT_LENGTH),
  }),
  errorCodeMap: {
    [ApiErrorCodes.CHANGE_REASON_REQUIRED]: { key: 'changeReason_En', message: 'common:error.fieldRequired' },
  },
});
